import API from "../../helpers/network/http";

export default class NotificationService {
    // Create a method to fetch notifications
    static async fetchNotifications(query: any): Promise<any> {

        // Call the login endpoint from the API
        const {data} = await API.get(`/notifications?page=${query?.page || 1}&limit=${query?.limit || 10}`);
        // Return the response
        return data;

    };

    // Create a method to fetch user notification
    static async fetchNotification(id: string): Promise<any> {

        // Call the login endpoint from the API
        const {data} = await API.get(`/notifications/${id}`, );

        // Return the response

        return data;

    }

    // Create a method to mark notification as read
    static async markNotificationAsRead(id: string): Promise<any> {

        // Call the login endpoint from the API
        const {data} = await API.put(`/notifications/${id}`, );

        // Return the response

        return data;

    }

    // Create a method to get notifications count
    static async getNotificationsCount(): Promise<any> {

        // Call the login endpoint from the API
        const {data} = await API.get(`/notifications/unread-count`, );

        // Return the response

        return data;

    }

    // Create a method to delete notification
    static async deleteNotification(id: string): Promise<any> {

        // Call the login endpoint from the API
        const {data} = await API.delete(`/notifications/${id}`, );

        // Return the response

        return data;

    }

}